import React from "react"
import Modal from "react-bootstrap/Modal"
import { navigate } from "gatsby"
import Loader from "../Loader"

const ConfirmModal = (props) => {
  const handleClose = () => {
    props.closePopup()
    // navigate("/business-support/get-started/")
  }

  return (
    <div>
      <Modal size="lg" show={props.show} centered>
        <Modal.Body className="p-0 rounded-20 position-relative">
          <div className="container"></div>
          <div className="row justify-content-center align-center confirm-modal_wrapper p-5">
            <h5 className="mb-3">Payment Confirmation</h5>
            <p>The sum of</p>
            <h4 className="amt">₦{props.amount}</h4>
            <p className="mt-3">would be debited from</p>
            <div>
              {props.account_no ? (
                <h6 className="client-account-no">
                  Account Number: {props.account_no}
                </h6>
              ) : (
                <h6 className="client-account-no">Your Sparkle Account</h6>
              )}
            </div>
            <div className="flex-column justify-content-center col-lg-6 ">
              <div className="form-group col-md-12 my-3">
                <button
                  type="button"
                  onClick={props.handlePayment}
                  className="btn sparkle--button__green sparkle--button__shadow px-5 btn-block w-100"
                >
                  Confirm
                  {props.btnLoader && (
                    <Loader width="30" color="#fff" display="inline-block" />
                  )}
                </button>
              </div>

              <div className="form-group col-md-12 my-3">
                <button
                  type="submit"
                  className="btn sparkle--button__green_outline px-5 w-100 btn-block"
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default ConfirmModal
